import {Typography} from "@mui/material";

export const InterestInfoContent = () => {

    return {
        title: 'Interest Rates',
        content: (
            <>
                <Typography paragraph>
                    Interest Rates provide the rate information used to
                    calculate interest amounts throughout the system.
                </Typography>

                <ul>

                    <li>
                        Rates may vary over time, allowing calculations
                        to use the appropriate rate for a specific period.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Interest Rate records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Interest Rate data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Interest Rate manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Interest Rate records.
                    </li>

                    <li>
                        Historical Interest Rates should be maintained
                        accurately to ensure that calculations performed
                        for prior periods produce consistent and auditable
                        results.
                    </li>

                </ul>
            </>
        )
    };

};




